<script setup lang="ts">
import { ref } from 'vue'
import type { AlgoliaDropdownFiltersProps } from './AlgoliaDropdownFilters.props'

withDefaults(defineProps<AlgoliaDropdownFiltersProps>(), {
  border: false,
  showMore: true,
  defaultOpen: false,
})

const { hideFilter } = await useTemplatePlp()

const isNoRefinement = ref(false)
const mainDiv = ref(null)

const route = useRoute()

const queryParams = computed(() => route.query)

const openMainAccordion = ref([])

onMounted(() => {
  isNoRefinement.value = hideFilter(mainDiv.value)
})

watch(queryParams, (newVal: any) => {
  const filterCategories = newVal?.refinementList?.[`macroCat`] ?? null

  if (filterCategories && filterCategories.length > 0) {
    openMainAccordion.value = filterCategories
  }
})

const numbersOfRefinements = (number: Number) => {
  if (number) {
    return `(${number.toString()}) `
  }
  return ``
}

const refineAndOpenFilters = (
  refine: (value: string) => void,
  value: string
) => {
  refine(value)

  const button = document.getElementById('algolia-category-filters')

  const isAccordioOpen = button?.getAttribute('aria-expanded')

  if (isAccordioOpen === 'false') {
    document.getElementById('algolia-category-filters')?.click()
  }
}
</script>

<template>
  <div
    :id="id"
    ref="mainDiv"
    :class="{ 'border-primitives-grey-100 border-t': border }"
  >
    <AisRefinementList :attribute="attribute">
      <template
        #default="{
          items,
          refine,
        }: {
          items: any
          refine: (value: string) => void
        }"
      >
        <UIDropdown
          click-id="algolia-subcategory-filters"
          :title="title"
          :right-text="
            numbersOfRefinements(
              (items[0] as unknown as RefinementGroup)?.refinementsList.filter(
                obj => obj.isRefined === true
              ).length
            )
          "
        >
          <div v-for="item in items" :key="item.title">
            <UIFilterDropdown
              :title="item.title"
              title-wrapper="h4"
              :click-id="`algolia-subcategory-filters-${item.title}`"
            >
              <div class="flex flex-col gap-6 font-light">
                <ul class="mb-4 flex flex-col gap-3">
                  <li
                    v-for="refinement in item.refinementsList"
                    :key="`${refinement.value}_${attribute}`"
                    class="flex gap-1"
                  >
                    <AtomsCheckbox
                      v-model="refinement.isRefined"
                      @refine="refineAndOpenFilters(refine, refinement.value)"
                    >
                      <template #label>
                        <span class="text-book-6">
                          {{ refinement?.label }}
                        </span>
                        <span
                          v-if="refinement?.count"
                          class="text-light-7 text-primitives-grey-200 mb-1 flex w-fit items-center"
                        >
                          ({{ refinement.count }})
                        </span>
                      </template>
                    </AtomsCheckbox>
                  </li>
                </ul>
              </div>
            </UIFilterDropdown>
          </div>
        </UIDropdown>
      </template>
    </AisRefinementList>
  </div>
</template>
